import React, { useContext, useEffect } from "react";

import { Grid, Grow } from "@material-ui/core";
import TextField from "../../../../components/basics/TextFieldErp";

import { PainelNfeContext } from "../contexts/PainelNfeContext";
import Select from "../../../../components/basics/SelectErp";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import Chip from "../../../../components/basics/Chip";
import SelectSituacaoDeVenda from "./SelectSituacaoDeVenda";
import { GlobalVariables } from "../../../../GlobalVariables";

const TabInutilizar = ({ ...props }) => {
  const {
    initialNumber,
    setInitialNumber,
    finalNumber,
    setFinalNumber,
    justify,
    setJustify,
    series,
    setSeries,
    listSeries,
    inutError,
    setHasSalesInNfe,
    model,
    setModel,
    selectedItem,
  } = useContext(PainelNfeContext);

  const { queryParams } = useContext(QueryParamsContext);

  const verifyAssemblyType =
    selectedItem?.[0]?.tipo_montagem ===
    GlobalVariables.nfe.assemblyType.automatic;

  setHasSalesInNfe(
    !!selectedItem.find((current) =>
      current.contasreceber?.find(
        (contareceber) => contareceber.origem === "NFe"
      )
    )
  );

  useEffect(() => {
    if (!listSeries.length) return;

    const serie = listSeries.find(
      (item) => item.serieNumber === parseInt(queryParams.serie_notafiscal)
    );

    setSeries(serie || null);
  }, [listSeries, queryParams.serie_notafiscal, setSeries]);

  return (
    <Grow in={true}>
      <Grid container spacing={3} key="tab-inutilizar">
        <Grid item xs={12}>
          <Chip
            bgcolor="secondary"
            title="true"
            label="O motivo da inutilização deve conter no mínimo 15 caracteres."
          />
        </Grid>
        {!selectedItem.length ? (
          <>
            <Grid item xs={4}>
              <Select
                getOptionLabel={(option) =>
                  `${option.serieNumber || "-"} - ${option.description || "-"}`
                }
                variant="outlined"
                value={series}
                setValue={setSeries}
                descriptionField="number"
                label="Série"
                optionsList={listSeries.filter(
                  (item) => item.model === `${model?.value}`
                )}
                error={inutError.series ? true : false}
                helperText={inutError.series || ""}
              />
            </Grid>
            <Grid item xs={2}>
              <Select
                variant="outlined"
                value={model}
                onChange={(value) => {
                  setModel(value);
                  setSeries(null);
                }}
                descriptionField="label"
                label="Modelo"
                optionsList={[
                  {
                    label: "55",
                    value: 55,
                  },
                  {
                    label: "65",
                    value: 65,
                  },
                ]}
                error={inutError.series ? true : false}
                helperText={inutError.series || ""}
              />
            </Grid>
            <Grid item xs>
              <TextField
                label="Nro Inicial"
                variant="outlined"
                setValue={setInitialNumber}
                value={initialNumber}
                mask="integer"
                error={inutError.initialNumber ? true : false}
                helperText={inutError.initialNumber || ""}
              />
            </Grid>
            <Grid item xs>
              <TextField
                label="Nro Final"
                variant="outlined"
                value={finalNumber}
                setValue={setFinalNumber}
                mask="integer"
                error={inutError.finalNumber ? true : false}
                helperText={inutError.finalNumber || ""}
              />
            </Grid>
          </>
        ) : (
          <>
            {selectedItem.map((note, index) =>
              note.status === "D" ? (
                <Chip
                  bgcolor="secondary"
                  label={`Nota Nro: ${note.numero} Série:  ${note.serie} Modelo: ${note.modelo}`}
                  key={`key-${index}`}
                />
              ) : (
                <></>
              )
            )}
            {verifyAssemblyType && <SelectSituacaoDeVenda />}
            <Grid item xs={12} />
          </>
        )}
        <Grid item xs={12}>
          <TextField
            label="Motivo de Inutilização"
            variant="filled"
            multiline
            rows={4}
            value={justify}
            setValue={setJustify}
            error={inutError.justify ? true : false}
            helperText={inutError.justify || ""}
          />
        </Grid>
      </Grid>
    </Grow>
  );
};

export default TabInutilizar;
